//@flow
import {makeStyles, FormControlLabel} from '@material-ui/core';
import React from 'react';
import MarkdownPreview from '../../../../../elements/MarkdownPreview';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {Delete, Edit} from '@material-ui/icons';
import {colors} from '../../../../../assets/styles/colors';

import type {HeaderBanner} from '../../../../../entities';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    width: '100%',
    flexDirection: 'column',
  },
  options: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    width: '100%',
    flexDirection: 'column',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  textContent: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    borderRadius: '.5rem',
    padding: '.75rem',
    width: '100%',
    justifyContent: 'center',
  },
  formControlLabel: {
    fontSize: '.875rem',
    fontWeight: 500,
    color: colors.grey700,
  },
  text: {
    all: 'unset',
    width: 'auto',
    color: 'inherit !important',
    '& *': {
      background: 'transparent !important',
      color: 'inherit !important',
    },
  },
  buttonOptions: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
  },
  buttonOption: {
    padding: '.5rem',
    background: 'transparent',

    '& span': {
      color: colors.grey700,
    },
  },
  editButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    color: colors.grey500,
  },
  deleteButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    color: colors.error,
  },
  bannerButton: {
    color: 'inherit',
    fontWeight: 600,
  },
}));

type Props = {
  banner: HeaderBanner,
  onDelete: (banner: HeaderBanner) => void,
  onEdit: (banner: HeaderBanner) => void,
  onToggleEnabled: (enabled: boolean) => void,
};

export default function BannerItem(props: Props) {
  const {banner, onDelete, onEdit, onToggleEnabled} = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.options}>
        <FormControlLabel
          control={
            <IosSwitch
              checked={banner.enabled}
              color="primary"
              onChange={e => onToggleEnabled(e.target.checked)}
            />
          }
          label={banner.enabled ? 'Activado' : 'Desactivado'}
          classes={{
            label: classes.formControlLabel,
          }}
          labelPlacement="end"
        />

        <div
          className={classes.buttonOptions}
          onClick={e => e.stopPropagation()}
        >
          <CustomButton
            className={classes.buttonOption}
            onClick={() => onEdit(banner)}
          >
            <div className={classes.editButton}>
              <Edit fontSize="small" />
              <span>Editar</span>
            </div>
          </CustomButton>
          <CustomButton
            className={classes.buttonOption}
            onClick={() => onDelete(banner)}
          >
            <div className={classes.deleteButton}>
              <Delete fontSize="small" />
              <span>Eliminar</span>
            </div>
          </CustomButton>
        </div>
      </span>

      <div
        className={classes.textContent}
        style={{
          background: banner.backgroundColor,
          color: banner.textColor,
        }}
      >
        <MarkdownPreview className={classes.text} value={banner.content} />
        {banner.buttonContent && (
          <span className={classes.bannerButton}>{banner.buttonContent}</span>
        )}
      </div>
    </div>
  );
}
